import React from 'react';
import { personalInfo } from '../data/portfolio';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section" aria-labelledby="about-title">
      <div className="container">
        <header className="section-header" data-eyebrow="About">
          <h2 id="about-title" className="section-title">About Me</h2>
          <p className="section-subtitle">Get to know the developer behind the code</p>
        </header>

        <div className="about__content">
          <div className="about__image-wrapper">
            <div className="about__image-frame">
              <div className="about__image-placeholder" aria-hidden="true">
                <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="8" r="5" />
                  <path d="M20 21c0-3.07-1.64-5.64-4.5-6.32V4a2 2 0 0 0-3-1.95v7.68c-2.86.68-4.5 3.25-4.5 6.32a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1z" />
                </svg>
              </div>
              <div className="about__badge">
                <span className="about__badge-text">React Native</span>
                <span className="about__badge-text">Developer</span>
              </div>
              <div className="about__experience-badge">
                <span className="about__years">3</span>
                <span className="about__years-label">Years Experience</span>
              </div>
            </div>
          </div>

          <div className="about__text">
            <h3 className="about__heading">{personalInfo.tagline}</h3>
            <div className="about__bio">
              <p>{personalInfo.bio}</p>
              <p>
                I specialize in building high-performance, cross-platform mobile applications
                using React Native. My expertise spans the entire development lifecycle from
                architecture design to App Store deployment, with a serverless AWS backend and
                CI/CD automation using EAS Build/Submit and GitHub Actions.
              </p>
            </div>

            <div className="about__highlights">
              <div className="about__highlight">
                <div className="about__highlight-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" />
                    <path d="M8 21h8M12 17v4" />
                  </svg>
                </div>
                <div className="about__highlight-content">
                  <h4 className="about__highlight-title">Mobile-First Architecture</h4>
                  <p className="about__highlight-desc">Building scalable React Native apps with clean architecture and offline-first design</p>
                </div>
              </div>

              <div className="about__highlight">
                <div className="about__highlight-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div className="about__highlight-content">
                  <h4 className="about__highlight-title">CI/CD Automation</h4>
                  <p className="about__highlight-desc">EAS Build/Submit and GitHub Actions for automated builds and store releases</p>
                </div>
              </div>

              <div className="about__highlight">
                <div className="about__highlight-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div className="about__highlight-content">
                  <h4 className="about__highlight-title">Serverless AWS Backends</h4>
                  <p className="about__highlight-desc">Amplify, AppSync, Cognito, Lambda, DynamoDB and S3 powering production mobile apps</p>
                </div>
              </div>

              <div className="about__highlight">
                <div className="about__highlight-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 6v6l4 2" />
                  </svg>
                </div>
                <div className="about__highlight-content">
                  <h4 className="about__highlight-title">Performance Optimization</h4>
                  <p className="about__highlight-desc">Smooth animations and faster startup times through profiling and targeted fixes</p>
                </div>
              </div>
            </div>

            <div className="about__stats">
              <div className="about__stat">
                <span className="about__stat-number">1</span>
                <span className="about__stat-label">App Published</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-number">2</span>
                <span className="about__stat-label">Platforms Shipped</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-number">6</span>
                <span className="about__stat-label">AWS Services Used</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-number">3</span>
                <span className="about__stat-label">Years of React Native</span>
              </div>
            </div>

            <div className="about__cta">
              <a href={personalInfo.resume} className="btn btn--primary btn--lg" download>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download Resume
              </a>
              <a href="#contact" className="btn btn--secondary btn--lg">Get In Touch</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
